// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"Likes-style__iconWrapper__250bee40","icon":"Likes-style__icon__250bee40","hasUnread":"Likes-style__hasUnread__250bee40"};